import { render, staticRenderFns } from "./ProcessPalette.vue?vue&type=template&id=ad2b6d86&scoped=true&"
import script from "./ProcessPalette.vue?vue&type=script&lang=js&"
export * from "./ProcessPalette.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPalette.vue?vue&type=style&index=0&id=ad2b6d86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b6d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2b6d86')) {
      api.createRecord('ad2b6d86', component.options)
    } else {
      api.reload('ad2b6d86', component.options)
    }
    module.hot.accept("./ProcessPalette.vue?vue&type=template&id=ad2b6d86&scoped=true&", function () {
      api.rerender('ad2b6d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/palette/ProcessPalette.vue"
export default component.exports